module.exports = __webpack_public_path__ + "assets/img/media_33.831a1d1e.png";